module.exports = __webpack_public_path__ + "img/QueXian02.d86794c8.jpg";